var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneric13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10487_18454)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FEC3DD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0574,
    y: 29.3222,
    width: 17.7333,
    height: 4.51111,
    rx: 2.25556,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.466667
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10487_18454)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.84708,
    y: 47.1119,
    width: 33.7556,
    height: 35.7778,
    rx: 16.8778,
    transform: "rotate(-16 6.84708 47.1119)",
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.466667
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9463,
    y: 37.8778,
    width: 9.48889,
    height: 4.51111,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.466667
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.1796,
    y: 37.6444,
    width: 9.02222,
    height: 6.22222,
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.7687,
    y: 17.5,
    width: 14.3111,
    height: 22.5556,
    rx: 7.15556,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.466667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.002 24.7333H22.2464L21.002 27.6889V24.7333Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8464 24.7333H33.602L34.8464 27.6889V24.7333Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-1_10487_18454",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2254 43.7111C35.9194 46.1322 32.3198 48.0431 27.9242 48.0431C23.5542 48.0431 19.9708 46.1543 19.6287 43.7532C13.7751 45.4297 9.49097 50.8214 9.49097 57.2137V67.7914H46.5132V57.2137C46.5132 50.7669 42.1557 45.3378 36.2254 43.7111Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2254 43.7111C35.9194 46.1322 32.3198 48.0431 27.9242 48.0431C23.5542 48.0431 19.9708 46.1543 19.6287 43.7532C13.7751 45.4297 9.49097 50.8214 9.49097 57.2137V67.7914H46.5132V57.2137C46.5132 50.7669 42.1557 45.3378 36.2254 43.7111Z",
    fill: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2254 43.7111L36.3488 43.2611L35.8299 43.1187L35.7624 43.6526L36.2254 43.7111ZM19.6287 43.7532L20.0907 43.6874L20.0152 43.1571L19.5002 43.3046L19.6287 43.7532ZM9.49097 67.7914H9.0243V68.2581H9.49097V67.7914ZM46.5132 67.7914V68.2581H46.9799V67.7914H46.5132ZM35.7624 43.6526C35.6369 44.6455 34.8166 45.6242 33.3916 46.3718C31.9814 47.1115 30.0594 47.5764 27.9242 47.5764V48.5098C30.1846 48.5098 32.2601 48.0192 33.8252 47.1983C35.3754 46.3851 36.5079 45.1978 36.6884 43.7696L35.7624 43.6526ZM27.9242 47.5764C25.8015 47.5764 23.8893 47.1169 22.4813 46.3846C21.0586 45.6446 20.2313 44.6739 20.0907 43.6874L19.1667 43.819C19.3683 45.2336 20.5036 46.4079 22.0507 47.2126C23.6124 48.0249 25.6769 48.5098 27.9242 48.5098V47.5764ZM9.95763 57.2137C9.95763 51.0351 14.0984 45.8225 19.7572 44.2018L19.5002 43.3046C13.4517 45.0369 9.0243 50.6076 9.0243 57.2137H9.95763ZM9.95763 67.7914V57.2137H9.0243V67.7914H9.95763ZM46.5132 67.3248H9.49097V68.2581H46.5132V67.3248ZM46.0465 57.2137V67.7914H46.9799V57.2137H46.0465ZM36.1019 44.1612C41.8348 45.7337 46.0465 50.9824 46.0465 57.2137H46.9799C46.9799 50.5513 42.4766 44.9419 36.3488 43.2611L36.1019 44.1612Z",
    fill: "#111111",
    mask: "url(#path-10-inside-1_10487_18454)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4902 20.0148L34.4996 20.0336L34.5122 20.0504C34.9197 20.5932 35.1788 20.9681 35.3661 21.3644C35.5519 21.7575 35.6719 22.1826 35.7833 22.8285L35.7848 22.837L35.7869 22.8454C36.012 23.7458 36.0133 24.9129 36.0133 25.5888C36.0133 26.1116 35.8688 31.0598 35.8072 33.1453C35.7882 33.7885 36.074 34.3999 36.5767 34.7991H35.1006L35.1135 28.3028V28.3023V27.7648V27.3437L34.7565 27.567C34.2109 27.9081 33.7594 28.1095 33.2567 28.2282C32.751 28.3475 32.182 28.3859 31.3947 28.386C30.0815 28.3244 28.9136 27.4965 28.101 26.3968C27.4573 25.5257 26.5162 24.768 25.3685 24.7146L21.402 24.5303C21.1858 24.5203 21.003 24.6887 20.9953 24.9049L20.9103 27.2839H20.9102L20.9102 27.2861L20.7092 34.8897H19.5946C19.5732 34.8897 19.5607 34.8836 19.5524 34.8771C19.5426 34.8696 19.5335 34.8574 19.5284 34.8417C19.5232 34.826 19.5234 34.8108 19.5268 34.799C19.5297 34.7888 19.5362 34.7765 19.5534 34.7639C19.9836 34.4485 20.2319 33.9423 20.2179 33.409L19.9912 24.7578C20.0813 22.553 20.9447 20.5331 22.5706 19.0406L22.5706 19.0406L22.572 19.0394C23.2307 18.4252 23.9775 17.942 24.7688 17.5899L24.8692 17.5514C26.8922 16.7755 29.1248 16.7419 31.1701 17.4565C32.4366 17.9812 33.5759 18.8539 34.456 19.9465L34.4902 20.0148Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.466667
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 54.5,
    height: 54.5,
    rx: 27.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10487_18454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10487_18454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2222,
    height: 49.7778,
    fill: "white",
    transform: "translate(10.891 3.73331)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric13);
export default __webpack_public_path__ + "static/media/Generic 13.84769e5c4166a298cd7531667e20d76b.svg";
export { ForwardRef as ReactComponent };